import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthProvider'
import { useConfig } from './ConfigProvider'
import { toast } from 'react-toastify'
import { SaveBasket, GetSavedBaskets, SaveBasketFromOrder, DeleteProductFromSavedBasket, AddSingleProductToSavedBasket, ChangeSavedBasketName } from '../Services/BasketService'

const SavedBasketsContext = createContext()

export const useSavedBaskets = () => {
    return useContext(SavedBasketsContext)
}

export const SavedBasketsProvider = ({ children }) => {
    const { authState } = useAuth()
    const { api } = useConfig()

    const [savedBaskets, setSavedBaskets] = useState([])
    const [isLoadingSavedBaskets, setIsLoadingSavedBaskets] = useState(false)
    const [selectedSavedBasket, setSelectedSavedBasket] = useState(null) //DK : wybrany szybkokoszyk do dodawania do niego pozycji z assortList

    useEffect(() => {
        handleGetSavedBasket()
    }, [api])

    const handleSaveBasket = async (basketItems, basketName) => {
        try {
            await SaveBasket(api, basketItems, authState.custId, basketName, authState.siteId, authState.whId)
            return true
        } catch (error) {
            console.log(error)
            toast.error('Nie udało się zapisać koszyka!')
            return false
        }
    }

    const handleSaveBasketFromOrder = async (basketItems, basketName) => {
        try {
            await SaveBasketFromOrder(api, basketItems, authState.custId, basketName)
            return true
        } catch (error) {
            console.log(error)
            toast.error('Nie udało się zapisać koszyka!')
            return false
        }
    }

    const handleGetSavedBasket = () => {
        setIsLoadingSavedBaskets(true)
        GetSavedBaskets(api, authState.custId, authState.siteId, authState.whId).then(res => {
            setSavedBaskets(res.data)
        }).catch(e => {
            console.log(e)
        }).finally(() => { setIsLoadingSavedBaskets(false) })
    }

    const getProductQuantityInSavedBasket = (product) => {
        if (!authState.user || !selectedSavedBasket || selectedSavedBasket.basketItems === null || selectedSavedBasket.basketItems === undefined) {
            return 0
        }
        var result = selectedSavedBasket.basketItems.find(e => e.artNo === product.index)
        if (result) {
            return result.qty
        }
        return 0
    }

    const deleteProductFromSavedBasket = async (basketId, artNo) => {
        try {
            const res = await DeleteProductFromSavedBasket(api, basketId, artNo)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const addSingleProductToSavedBasket = async (basketId, index, qty) => {
        try {
            const res = await AddSingleProductToSavedBasket(api, basketId, index, qty)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const changeSavedBasketName = async (basketId, name) => {
        try {
            const res = await ChangeSavedBasketName(api, basketId, name)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }


    return (
        <SavedBasketsContext.Provider value={{
            handleSaveBasket,
            handleSaveBasketFromOrder,
            setIsLoadingSavedBaskets,
            handleGetSavedBasket,
            setSavedBaskets,
            setSelectedSavedBasket,
            getProductQuantityInSavedBasket,
            deleteProductFromSavedBasket,
            addSingleProductToSavedBasket,
            changeSavedBasketName,
            savedBaskets,
            isLoadingSavedBaskets,
            selectedSavedBasket,
        }}>
            {children}
        </SavedBasketsContext.Provider>
    )
}